import {capitalize} from 'lodash-es'
import {getBaseRoomType} from 'root-packages/accommodation/sharedRoomsUtils.js'

function countPassengersInRooms (rooms = [], baseRoomType) {
  return rooms.reduce((total, room) => {
    if (baseRoomType && baseRoomType !== getBaseRoomType(room)) {
      return total
    }
    return total + (room.adults + room.children) * room.count
  }, 0)
}

function isAllocationAvailable (rooms = [], roomsOccupancy = {}) {
  return rooms.every(room => {
    const roomType = getBaseRoomType(room)
    const numberOfPassengersInRoomType = countPassengersInRooms(rooms, roomType)

    return roomsOccupancy[roomType] === 'available' &&
      numberOfPassengersInRoomType <= roomsOccupancy[`freeSaleLimit${capitalize(roomType)}`]
  })
}


function hasAlternativeRoomAllocation (roomAllocations = [], roomsOccupancy = {}) {
  return roomAllocations.some(roomAllocation => {
    return isAllocationAvailable(roomAllocation.rooms, roomsOccupancy)
  })
}

export default ({
  rooms,
  roomsOccupancy,
  roomAllocations,
  cbTripOnRequest = () => {},
  cbRoomOnRequest = () => {},
  cbNextTab = () => {},
}) => {
  const {freeSaleLimit: freeSaleLimitCoach} = roomsOccupancy
  const numberOfPassengers = countPassengersInRooms(rooms)

  const isCoachFull = numberOfPassengers > freeSaleLimitCoach
  const isSelectedAllocationOnRequest = !isAllocationAvailable(rooms, roomsOccupancy)
  const isTripOnRequest = isCoachFull || (
    isSelectedAllocationOnRequest &&
    !hasAlternativeRoomAllocation(roomAllocations, roomsOccupancy)
  )

  if (isTripOnRequest) {
    cbTripOnRequest()
  } else if (isSelectedAllocationOnRequest) {
    cbRoomOnRequest()
  } else {
    cbNextTab()
  }

  return isTripOnRequest || isSelectedAllocationOnRequest
}

